<template>
  <div
    v-if="logo"
  >
  <v-img
    v-if="mapOnlyMode"
    v-show="$store.state.displayMap"
    :src="`./${logo}`"
    class="logo"
    contain
    style="position:fixed;"
    :style="$mq | mq({
      mobile: 'top:2%;width:40%;margin:0 30%;',
      tablet: 'bottom:2%;width:20%;margin:0 98% 0 2%;',
      desktop: 'bottom:2%;width:10%;margin:0 98% 0 2%;'
    })"
  />
  <v-img
    v-else
    v-show="$store.state.displayMap"
    :src="`./${logo}`"
    class="logo"
    contain
    style="position:fixed;"
    :style="$mq | mq({
      mobile: 'top:2%;width:40%;margin:0 30%;',
      tablet: 'bottom:2%;width:20%;margin:0 40%;',
      desktop: 'bottom:2%;width:10%;margin:0 45%;'
    })"
  />
  </div>
</template>

<script>


export default {
  name: 'ClientLogo',
  data() {
    return {
      logo: this.$appConfig.logo,
      displayed: true,
      mapOnlyMode: this.$appConfig.mapOnlyMode,
    };
  },
  mounted() {},
};

</script>

<style scoped>
.logo {
  z-index: 9;
}
</style>
